<template>
    <div v-if="isLoaded" class="error-msg-wrap">
        <div class="form-wrapper slide-up crm-form-wrapper" style="width:1100px">
            <div :class="formData.CardColor == '#000000' ? 'card-color-cover card-color-cover-black' : 'card-color-cover'" :style="formData.CardColor ? 'background:'+formData.CardColor : ''">
                <div class="card-color-cover-edit" title="Card color" @click="() => { showEditColorCover = !showEditColorCover }"><svg-icon icon="image" /></div>
                <div class="form-close">
                    <button type="button" class="form-close-x" title="Close" @click="$emit('close')">&times;</button>
                </div>
                <div v-if="showEditColorCover" class="board-item-tags card-color-pop">
                    <div class="card-color-pop-head">
                        <b>Card color</b>
                        <span class="board-item-tags-close" @click="() => { showEditColorCover = false }"><svg-icon icon="x" /></span>
                    </div>
                    <div class="crm-board-color-select">
                        <select v-model="formData.CardColor" @change="fieldChange(null)">
                            <option :value="null">No color</option>
                            <option v-for="(color, i) in $store.state.colorPalette" :key="i" :value="color.hex">{{ color.label }}</option>
                        </select>
                        <input type="color" :value="formData.CardColor || '#DDDDDD'" @change="setCustomCardColor" title="Custom color" />
                    </div>
                    <a v-if="formData.CardColor" class="card-color-pop-clear" @click.prevent="() => { formData.CardColor = null; showEditColorCover = false; fieldChange(null); }">Remove color</a>
                </div>
            </div>
            <div class="qc-item-wrap crm-item-wrap">
                <div>
                    <input type="text" class="h3-text-input" v-model="formData.Name" placeholder="Enter Name" @change="fieldChange('name')" />

                    <div v-if="displayTags.length || dateInfo" class="customer-request-tags">
                        <div v-if="dateInfo" :style="dateInfo.Overdue ? 'background:red' : 'background:#FBC828;color:black'"><svg-icon icon="clock" style="width:16px;height:16px;margin-right:5px;fill:currentColor" />{{ dateInfo.DateDisplay }}</div>
                        <div v-for="(tag, i) in displayTags" :key="i" :style="'background:'+tag.color">{{ tag.name }}</div>
                    </div>

                    <!-- The boards this card is on besides this one; the links open it there -->
                    <div v-if="formData.HomeBoard || otherMirrorBoards.length" class="crm-item-mirrors">
                        <svg-icon icon="copy" />
                        <span>
                            <template v-if="formData.HomeBoard">Mirrored from <a v-if="canOpenBoard(formData.HomeBoard)" @click.prevent="openOnBoard(formData.HomeBoard)">{{ formData.HomeBoard.Name }}</a><b v-else>{{ formData.HomeBoard.Name }}</b></template>
                            <template v-if="otherMirrorBoards.length">{{ formData.HomeBoard ? ', also on ' : 'Also on ' }}<template v-for="(board, i) in otherMirrorBoards" :key="board.Slug">{{ i ? ', ' : '' }}<a v-if="canOpenBoard(board)" @click.prevent="openOnBoard(board)">{{ board.Name }}</a><b v-else>{{ board.Name }}</b></template></template>
                        </span>
                    </div>

                    <div class="board-item-btns">
                        <div>
                            <span @click="() => { showTags = true; }">Tags</span>
                            <div v-if="showTags" class="board-item-tags">
                                <div class="board-item-tags-close" @click="closeTags()"><svg-icon icon="x" /></div>
                                <div class="board-item-tags-tags">
                                    <div v-if="!allTags.length" style="font-weight:normal">This board has no tags yet. Add them from Edit Tags on the board.</div>
                                    <div v-for="(tag, i) in allTags" :key="i" class="checkbox-input customer-request-tag" :style="'background:'+tag.color">
                                        <input style="margin-left: 10px" type="checkbox" v-model="tag.checked" />
                                        <span>{{ tag.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <span @click="showAddChecklistFn()">Checklist</span>
                            <div v-if="showAddChecklist" class="board-item-tags">
                                <div class="board-item-tags-close" @click="() => { showAddChecklist = false }"><svg-icon icon="x" /></div>
                                <form @submit.prevent="addChecklist()" class="inline-plus-input">
                                    <input type="text" class="input-slim" v-model="addChecklistInput" placeholder="Add Checklist" ref="addChecklistInput" />
                                    <button class="btn"><span>Add</span></button>
                                </form>
                            </div>
                        </div>
                        <div>
                            <span @click="() => { showDueDate = true; }">Due Date</span>
                            <div v-if="showDueDate" class="board-item-tags">
                                <div class="board-item-tags-close" @click="() => { showDueDate = false }"><svg-icon icon="x" /></div>
                                <input type="date" class="input-slim" style="margin:0;width:100%" v-model="formData.Date" @change="fieldChange('due date')" />
                                <div v-if="formData.Date" style="margin-top:10px;font-weight:normal"><a style="cursor:pointer;text-decoration:underline" @click.prevent="() => { formData.Date = null; showDueDate = false; fieldChange('due date'); }">Remove due date</a></div>
                            </div>
                        </div>
                        <!-- Nothing is mirrored into or out of an inbox -->
                        <div v-if="!inInbox">
                            <span @click="openMirror()">Mirror</span>
                            <form v-if="showMirror" class="board-item-tags crm-mirror-pop" @submit.prevent="submitMirror()">
                                <div class="board-item-tags-close" @click="() => { showMirror = false }"><svg-icon icon="x" /></div>
                                <div class="crm-mirror-hint">Show this card on another board too. Edits on either board show on both.</div>
                                <div v-if="!mirrorTargets.length" class="crm-mirror-hint">There are no other boards to mirror it onto.</div>
                                <template v-else>
                                    <div class="crm-item-label">Board</div>
                                    <select v-model="mirrorSlug" @change="() => { mirrorColumn = mirrorColumns[0] || '' }">
                                        <option v-for="board in mirrorTargets" :key="board.Slug" :value="board.Slug">{{ board.Name }}</option>
                                    </select>
                                    <div class="crm-item-label">Column</div>
                                    <select v-model="mirrorColumn">
                                        <option v-for="column in mirrorColumns" :key="column" :value="column">{{ column }}</option>
                                    </select>
                                    <button :class="mirroring ? 'btn disable-button' : 'btn'">Mirror</button>
                                </template>
                            </form>
                        </div>
                        <div>
                            <span @click="openMove()">Move</span>
                            <form v-if="showMove" class="board-item-tags crm-mirror-pop" @submit.prevent="submitMove()">
                                <div class="board-item-tags-close" @click="() => { showMove = false }"><svg-icon icon="x" /></div>
                                <div class="crm-mirror-hint">{{ formData.HomeBoard ? `Move this mirror to another board. The card stays on ${formData.HomeBoard.Name}.` : 'Move this card to another board, with its comments, files and activity.' }}</div>
                                <div v-if="!moveTargets.length" class="crm-mirror-hint">There are no other boards to move it to.</div>
                                <template v-else>
                                    <div class="crm-item-label">Board</div>
                                    <select v-model="moveSlug" @change="() => { moveColumn = moveColumns[0] || '' }">
                                        <option v-for="board in moveTargets" :key="board.Slug" :value="board.Slug">{{ board.Name }}</option>
                                    </select>
                                    <div class="crm-item-label">Column</div>
                                    <select v-model="moveColumn">
                                        <option v-for="column in moveColumns" :key="column" :value="column">{{ column }}</option>
                                    </select>
                                    <button :class="moving ? 'btn disable-button' : 'btn'">Move</button>
                                </template>
                            </form>
                        </div>
                        <div>
                            <span @click="() => { showActivity = !showActivity; }">Activity</span>
                        </div>
                        <div>
                            <span @click="() => { showConfirmDelete = true; }">{{ formData.HomeBoard ? 'Remove' : 'Delete' }}</span>
                        </div>
                        <!-- Move to the last column, its name cut to 20 characters (in full on hover) -->
                        <div v-if="lastColumn && formData.Column != lastColumn">
                            <span :title="lastColumn" @click="() => { showMoveLastColumnConfirm = true }">{{ lastColumn.length > 20 ? lastColumn.slice(0, 20).trimEnd() + '…' : lastColumn }}</span>
                        </div>
                    </div>

                    <!-- Phones show one column at a time, so a card can only change columns here; touch screens get the picker -->
                    <template v-if="isTouchDevice()">
                        <div class="crm-item-label">Column</div>
                        <select v-model="formData.Column" style="margin-bottom:0" @change="columnChange()">
                            <option v-for="(column, i) in columns" :key="i" :value="column.name">{{ column.name }}</option>
                        </select>
                    </template>

                    <div class="crm-item-label">Description</div>
                    <div v-if="editDescription">
                        <div class="board-tip-tap">
                            <tip-tap v-model="formData.Description" :hide-h3="true" :hide-h4="true" :hide-table="true" />
                        </div>
                        <div style="margin-top:10px;display:flex">
                            <div @click="() => { fieldChange('description'); editDescription = false; }" class="btn" style="margin:0">Save</div>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="formData.Description" class="board-tip-tap">
                            <tip-tap :key="descriptionVersion" :model-value="formData.Description" :read-only="true" />
                        </div>
                        <div style="margin-top:10px;display:flex">
                            <div @click="() => { editDescription = true; }" class="btn" style="margin:0">{{ formData.Description ? 'Edit' : 'Add a description' }}</div>
                        </div>
                    </div>

                    <!-- The Forge writes a checklist of steps from the card (ForgeCardSteps) -->
                    <forge-card-steps v-if="formData.ID" :card="{ name: formData.Name, description: formData.Description, dueDate: formData.Date, existingSteps: formData.ChecklistJSON.flatMap((l: any) => l.items.map((it: any) => it.name)) }" @add="addForgeSteps" />

                    <div v-for="(list, i) in formData.ChecklistJSON" :key="'list' + i">
                        <div class="crm-checklist-head">
                            <input class="h3-text-input" type="text" v-model="list.name" placeholder="Enter Name" @change="submitChecklist(false, list.name)" />
                            <div class="board-item-btns">
                                <div>
                                    <span @click="removeChecklist(i)">Delete</span>
                                </div>
                            </div>
                        </div>
                        <div v-if="list.items.length" class="crm-checklist-progress"><div :style="'width:' + checklistPercent(list) + '%'"></div></div>
                        <!-- Items are dragged by their handle only, so the text and date stay editable (and work on touch) -->
                        <draggable :list="list.items" group="checklist" @change="submitChecklist(false, null)" class="crm-board-checklist-checks" handle=".crm-checklist-handle" :animation="150" ghost-class="kanban-ghost">
                            <div class="checkbox-input" v-for="(item, j) in list.items" :key="j">
                                <span class="crm-checklist-handle" title="Drag to reorder" aria-hidden="true">&#8942;&#8942;</span>
                                <input type="checkbox" v-model="item.checked" @change="submitChecklist(true, list.name)" />
                                <div :class="item.checked ? 'crm-checklist-item-row checked' : 'crm-checklist-item-row'">
                                    <textarea class="inline-text-input" rows="1" v-model="item.name" @change="submitChecklist(false, list.name)"></textarea>
                                    <!-- Phones show an empty date field as blank, so touch screens get a hint over it (style.scss) -->
                                    <div class="crm-checklist-date">
                                        <input class="text-input-no-style crm-checklist-date-input" type="date" v-model="item.date" @change="submitChecklist(false, list.name)" />
                                        <span v-if="!item.date" class="crm-checklist-date-ph" aria-hidden="true">Add date</span>
                                    </div>
                                    <span class="crm-x" title="Remove item" @click="removeChecklistItem(list, j)"><svg-icon icon="x" /></span>
                                </div>
                            </div>
                        </draggable>
                        <form v-show="list.showAddItem" @submit.prevent="addChecklistItem(list, i)" class="inline-plus-input crm-checklist-add">
                            <input :id="checklistInputID(i)" class="input-slim" type="text" v-model="list.addChecklistItemInput" placeholder="Add Checklist Item" @keyup.esc="() => { list.showAddItem = false }" />
                            <button class="btn"><span>Add</span></button>
                        </form>
                        <div v-show="!list.showAddItem" class="inline-plus-input crm-checklist-add">
                            <button type="button" class="btn" @click="listShowAddItem(list, i)"><span>Add an item</span></button>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="crm-comment-section">
                        <div class="crm-comments-header"><b>Comments</b></div>
                        <form class="crm-comment-form" @submit.prevent="submitComment()">
                            <div><textarea v-model="commentInput" placeholder="Write a comment..."></textarea></div>
                            <div style="display:flex"><input :class="disableButtonComment ? 'disable-button btn' : 'btn'" type="submit" value="Save" /></div>
                        </form>
                        <div v-if="comments.length" class="crm-comments">
                            <div class="crm-comment" v-for="(comment, i) in comments" :key="i">
                                <form v-if="comment.edit" class="crm-comment-form" style="margin-bottom:10px" @submit.prevent="submitCommentEdit(comment)">
                                    <div><textarea v-model="comment.commentInput"></textarea></div>
                                    <div style="display:flex"><input :class="disableButtonComment ? 'disable-button btn' : 'btn'" type="submit" value="Save" /></div>
                                </form>
                                <div v-else v-html="comment.Comment"></div>
                                <div class="crm-comment-meta">
                                    <span v-if="comment.CreatedBy">- {{ comment.CreatedBy }}</span>
                                    <span class="crm-comment-date">{{ new Date(comment.DateCreated).toLocaleDateString(undefined, { dateStyle: 'short' }) }}</span>
                                    <a v-if="comment.CanEdit" @click.prevent="() => { comment.edit = !comment.edit }">{{ comment.edit ? 'Close' : 'Edit' }}</a>
                                    <span v-if="comment.CanDelete" class="crm-x" title="Delete comment" @click="deleteComment(comment)"><svg-icon icon="x" style="margin-left:0" /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="crm-item-section-head">
                        <h3>Files</h3>
                        <div class="board-item-btns">
                            <div>
                                <span @click="() => { showAddFile = !showAddFile; showAddLink = false }">Add File</span>
                            </div>
                            <div>
                                <span @click="() => { showAddFile = false; showAddLink = !showAddLink }">Add Link</span>
                            </div>
                        </div>
                    </div>
                    <div v-if="showAddFile">
                        <drop-file @fileChange="onFileChange" style="margin-bottom: 20px" />
                    </div>
                    <form v-if="showAddLink" @submit.prevent="submitLink()" style="margin-bottom:20px">
                        <div><input class="input-slim" style="margin:0 0 10px" type="text" v-model="linkNameInput" placeholder="Name" /></div>
                        <div><input class="input-slim" style="margin:0" type="text" v-model="linkURLInput" placeholder="URL" /></div>
                        <div class="inline-plus-input" style="margin-top:10px">
                            <button style="margin:0 !important;font-size:12px" class="btn"><span>Add</span></button>
                        </div>
                    </form>
                    <div class="crm-item-file-list">
                        <div v-for="(file, i) in files" :key="i">
                            <a v-if="file.IsExternal" :href="file.SpacesPath" target="_blank" rel="noopener">{{ file.Name }}</a>
                            <a v-else :href="$store.state.apiUrl + $store.state.spacesUrl + file.SpacesPath" target="_blank">{{ file.Name }}</a>
                            <span class="crm-x" title="Remove file" @click="deleteFile(file)"><svg-icon icon="x" /></span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="showActivity" class="board-activity board-activity-card">
                <div class="form-close">
                    <button type="button" class="form-close-x" title="Close" @click="() => { showActivity = false }">&times;</button>
                </div>
                <div class="board-activity-list">
                    <div v-if="!activity.length">No activity in the last 60 days.</div>
                    <div v-for="(a, i) in activity" :key="i">
                        <div class="board-activity-date">{{ a.DateDisplay }}</div>
                        <div><b>{{ a.Username }}</b> {{ a.Text }} {{ formData.Name }}</div>
                    </div>
                </div>
            </div>
        </div>

        <confirm-delete v-if="showConfirmDelete" @confirm="deleteItemCB" @cancel="() => { showConfirmDelete = false; }" :msg="deleteMessage"/>
        <confirm-delete v-if="showConfirmRemoveChecklist" @confirm="removeChecklistCB" @cancel="() => { showConfirmRemoveChecklist = false; }" msg="Are you sure you would like to delete this checklist?"/>
        <confirm-delete v-if="showConfirmRemoveChecklistItem" @confirm="removeChecklistItemConfirm" @cancel="() => { showConfirmRemoveChecklistItem = false; }" msg="Are you sure you would like to remove this checklist item?"/>
        <confirm-delete v-if="showConfirmDeleteComment" @confirm="confirmCommentDelete" @cancel="() => { showConfirmDeleteComment = false; }" msg="Are you sure you would like to delete this comment?"/>
        <confirm-delete v-if="showConfirmFileDelete" @confirm="confirmFileDelete" @cancel="() => { showConfirmFileDelete = false; }" msg="Are you sure you would like to remove this file?"/>
        <confirm-delete v-if="showMoveLastColumnConfirm" @confirm="moveToLastColumn" @cancel="() => { showMoveLastColumnConfirm = false; }" :msg="'Are you sure you would like to move this card to ' + lastColumn + '?'"/>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import axios from 'axios';
import DropFile from './DropFile.vue';
import ConfirmDelete from './ConfirmDelete.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import TipTap from '@/components/TipTap.vue';
import ForgeCardSteps from '@/components/ForgeCardSteps.vue';
import { VueDraggableNext } from 'vue-draggable-next';

export default defineComponent({
    name: 'AddEditCompanyBoardItem',
    // defaultMoveSlug: the board Move offers first (the board being viewed, for a card opened from the inbox)
    props: [ 'item', 'tags', 'columns', 'defaultMoveSlug' ],
    emits: [ 'close' ],
    components: {
        draggable: VueDraggableNext,
        DropFile,
        ConfirmDelete,
        SvgIcon,
        TipTap,
        ForgeCardSteps
    },
    data() {
        return {
            disableButtonComment: false,
            formData: {} as any,
            isLoaded: false,
            allTags: [] as any,
            files: [] as any,
            comments: [] as any,
            commentInput: '',
            activity: [] as any,
            showActivity: false,
            showConfirmDelete: false,
            showTags: false,
            showDueDate: false,
            showEditColorCover: false,
            showMoveLastColumnConfirm: false,
            editDescription: false,
            descriptionVersion: 0,
            showAddChecklist: false,
            addChecklistInput: '',
            listIndexToRemove: -1,
            showConfirmRemoveChecklist: false,
            checklistToRemoveItem: null as any,
            checklistToRemoveItemIndex: -1,
            showConfirmRemoveChecklistItem: false,
            commentToDelete: null as any,
            showConfirmDeleteComment: false,
            showAddFile: false,
            showAddLink: false,
            linkNameInput: '',
            linkURLInput: '',
            fileToDelete: null as any,
            showConfirmFileDelete: false,
            // Boards the user can open, for the Mirror picker and the links to the card's other boards, plus their
            // inbox (IsInbox) as a Move target
            boards: [] as any,
            inboxSlug: null as string | null,
            showMirror: false,
            mirrorSlug: '',
            mirrorColumn: '',
            mirroring: false,
            showMove: false,
            moveSlug: '',
            moveColumn: '',
            moving: false
        }
    },
    computed: {
        // The boards it's mirrored on, other than this one
        otherMirrorBoards(): any[] {
            return (this.formData.MirrorBoards || []).filter((b: any) => b.Slug != this.formData.Slug);
        },
        // Boards it isn't on yet
        mirrorTargets(): any[] {
            const on = [ this.formData.HomeBoard ? this.formData.HomeBoard.Slug : this.formData.Slug, ...(this.formData.MirrorBoards || []).map((b: any) => b.Slug) ];
            return this.boards.filter((b: any) => !b.IsInbox && !on.includes(b.Slug));
        },
        inInbox(): boolean {
            return !!this.inboxSlug && this.formData.Slug == this.inboxSlug;
        },
        mirrorColumns(): string[] {
            const board = this.boards.find((b: any) => b.Slug == this.mirrorSlug);
            return board ? board.Columns : [];
        },
        // Where it can move: the card itself, to any other board (a mirror of it there makes way); a mirror, to a
        // board the card isn't on yet
        moveTargets(): any[] {
            const off = this.formData.HomeBoard
                ? [ this.formData.HomeBoard.Slug, this.formData.Slug, ...(this.formData.MirrorBoards || []).map((b: any) => b.Slug) ]
                : [ this.formData.Slug ];
            return this.boards.filter((b: any) => !off.includes(b.Slug));
        },
        moveColumns(): string[] {
            const board = this.boards.find((b: any) => b.Slug == this.moveSlug);
            return board ? board.Columns : [];
        },
        deleteMessage(): string {
            if(this.formData.HomeBoard) {
                return `Are you sure you would like to remove this card from this board? It stays on ${this.formData.HomeBoard.Name}` + (this.otherMirrorBoards.length ? ' and the other boards it\'s mirrored on.' : '.');
            }
            const count = (this.formData.MirrorBoards || []).length;
            return 'Are you sure you would like to delete this card?' + (count ? ` It's mirrored on ${count} other board${count == 1 ? '' : 's'} and will be removed from ${count == 1 ? 'it' : 'them'} too.` : '');
        },
        displayTags(): any[] {
            return this.allTags.filter((t: any) => t.checked);
        },
        lastColumn(): string {
            return this.columns?.length ? this.columns[this.columns.length - 1].name : '';
        },
        // Due date chip: "Oct 8" (or "Oct 8, 2025" outside this year); red once past, unless checked off or done
        dateInfo(): any {
            if(!this.formData.Date) {
                return null;
            }
            const [year, month, day] = String(this.formData.Date).split('-').map((p: string) => parseInt(p));
            let display = `${this.$store.state.monthShortStrings[month]} ${day}`;
            if(year != new Date().getFullYear()) {
                display += ', ' + year;
            }
            // Overdue the day after it's due (same as CompanyBoard.vue dateInfo and meeting boards)
            const now = new Date();
            const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
            const overdue = String(this.formData.Date).slice(0, 10) < today && !this.formData.Checked && this.formData.Column != this.lastColumn;
            return { DateDisplay: display, Overdue: overdue };
        }
    },
    async created() {
        this.formData = JSON.parse(JSON.stringify(this.$props.item));
        this.allTags = JSON.parse(JSON.stringify(this.$props.tags || []));

        let checklists = [];
        try {
            checklists = this.formData.ChecklistJSON ? JSON.parse(this.formData.ChecklistJSON) : [];
        } catch(e) {
            console.log(e);
        }
        for(const list of checklists) {
            list.items = list.items || [];
            list.showAddItem = false;
            list.addChecklistItemInput = '';
        }
        this.formData.ChecklistJSON = checklists;

        // Descriptions used to be plain text; show their line breaks in the rich text editor
        if(this.formData.Description && !/<[a-z][\s\S]*>/i.test(this.formData.Description)) {
            this.formData.Description = this.formData.Description.split('\n').map((line: string) => {
                const p = document.createElement('p');
                p.textContent = line;
                return p.outerHTML;
            }).join('');
        }

        for(const tag of this.formData.TagsJSON || []) {
            const allTag = this.allTags.find((t: any) => t.name == tag);
            if(allTag) {
                allTag.checked = true;
            }
        }

        await Promise.all([ this.getFiles(), this.getComments(), this.getActivity(), this.getBoards() ]);

        this.isLoaded = true;
    },
    methods: {
        // Saves the card. changedField ("name", "tags", ...) is logged to the activity; null skips logging
        async submit(changedField: string|null) {
            if(!this.formData.Name) {
                alert('Include name');
                return;
            }

            this.formData.TagsJSON = this.displayTags.map((t: any) => t.name);

            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems`, { ...this.formData, ChecklistJSON: undefined, changedField })
                .then(() => {
                    if(changedField) {
                        this.getActivity();
                    }
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error')
                })
        },
        async getBoards() {
            const inbox = axios.get(`${this.$store.state.apiUrl}/api/inbox`).then(resp => resp.data).catch(() => null);
            await axios.get(`${this.$store.state.apiUrl}/api/companyboards`)
                .then(resp => {
                    this.boards = resp.data.map((b: any) => {
                        let columns = [];
                        try {
                            columns = JSON.parse(b.Columns || '[]').map((c: any) => c.name);
                        } catch(e) {
                            console.log(e);
                        }
                        return { Slug: b.Slug, Name: b.Name, Columns: columns };
                    });
                })
                .catch(e => {
                    console.log(e);
                })
            // Your inbox first, so a deck card can be parked there without dragging (touch screens)
            const data = await inbox;
            if(data?.Slug) {
                this.inboxSlug = data.Slug;
                this.boards.unshift({ Slug: data.Slug, Name: 'Your Inbox', Columns: [ 'Inbox' ], IsInbox: true });
            }
        },
        canOpenBoard(board: any): boolean {
            return this.boards.some((b: any) => !b.IsInbox && b.Slug == board.Slug);
        },
        // Opens this card on another board it's on (links there go by its home card's ID)
        openOnBoard(board: any) {
            this.$router.push(`/deck/${board.Slug}?openCard=${this.formData.MirrorOfItemID || this.formData.ID}`);
        },
        openMirror() {
            this.showMirror = !this.showMirror;
            if(this.showMirror && !this.mirrorTargets.find((b: any) => b.Slug == this.mirrorSlug)) {
                this.mirrorSlug = this.mirrorTargets.length ? this.mirrorTargets[0].Slug : '';
                this.mirrorColumn = this.mirrorColumns[0] || '';
            }
        },
        async submitMirror() {
            if(!this.mirrorSlug || this.mirroring) {
                return;
            }
            this.mirroring = true;
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/mirror`, { Slug: this.formData.Slug, ID: this.formData.ID, TargetSlug: this.mirrorSlug, Column: this.mirrorColumn })
                .then(resp => {
                    this.formData.MirrorBoards = [ ...(this.formData.MirrorBoards || []), { Slug: resp.data.Slug, Name: resp.data.Name } ];
                    this.showMirror = false;
                    this.getActivity();
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error.');
                })
            this.mirroring = false;
        },
        openMove() {
            this.showMove = !this.showMove;
            if(this.showMove && !this.moveTargets.find((b: any) => b.Slug == this.moveSlug)) {
                const preferred = this.moveTargets.find((b: any) => b.Slug == this.defaultMoveSlug);
                this.moveSlug = preferred ? preferred.Slug : this.moveTargets.length ? this.moveTargets[0].Slug : '';
                this.moveColumn = this.moveColumns[0] || '';
            }
        },
        // Off this board: the modal closes and the board reloads without it
        async submitMove() {
            if(!this.moveSlug || this.moving) {
                return;
            }
            this.moving = true;
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/move`, { Slug: this.formData.Slug, ID: this.formData.ID, TargetSlug: this.moveSlug, Column: this.moveColumn })
                .then(() => {
                    this.$emit('close');
                })
                .catch(e => {
                    console.log(e);
                    alert(e?.response?.data || 'There was an error.');
                })
            this.moving = false;
        },
        setCustomCardColor(e: Event) {
            this.formData.CardColor = (e.target as HTMLInputElement).value;
            this.fieldChange(null);
        },
        fieldChange(changedField: string|null) {
            this.submit(changedField);
            if(changedField == 'description') {
                this.descriptionVersion++;
            }
        },
        closeTags() {
            this.submit('tags');
            this.showTags = false;
        },
        async onFileChange(file: any) {
            if(file) {
                const formData = new FormData();
                formData.append('file', file);
                formData.set('ID', this.formData.ID);
                formData.set('Slug', this.formData.Slug);
                await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/file`, formData)
                    .then(() => {
                        this.showAddFile = false;
                        this.getFiles();
                        this.getActivity();
                    })
                    .catch(e => {
                        console.log(e);
                        alert("There was an error.");
                    })
            }
        },
        async getFiles() {
            await axios.get(`${this.$store.state.apiUrl}/api/companyboarditems/files/${this.formData.Slug}?itemID=${this.formData.ID}`)
                .then(resp => {
                    this.files = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        async submitLink() {
            if(!this.linkNameInput || !this.linkURLInput) {
                return;
            }
            let url = this.linkURLInput.trim();
            if(!/^https?:\/\//i.test(url)) {
                url = 'https://' + url;
            }
            if(!url.includes('.')) {
                alert('Make sure your URL is formatted correctly');
                return;
            }
            const data = {
                url,
                name: this.linkNameInput,
                itemID: this.formData.ID,
                slug: this.formData.Slug
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/externalfile`, data)
                .then(() => {
                    this.linkURLInput = '';
                    this.linkNameInput = '';
                    this.showAddLink = false;
                    this.getFiles();
                    this.getActivity();
                })
                .catch(e => {
                    alert(e?.response?.data || 'There was an error.');
                })
        },
        deleteFile(file: any) {
            this.fileToDelete = file;
            this.showConfirmFileDelete = true;
        },
        async confirmFileDelete() {
            this.showConfirmFileDelete = false;
            await axios.delete(`${this.$store.state.apiUrl}/api/companyboarditems/file/${this.fileToDelete.ID}`)
                .then(() => {
                    this.getFiles();
                })
                .catch(e => {
                    alert(e?.response?.data || 'There was an error.');
                })
        },
        async getComments() {
            await axios.get(`${this.$store.state.apiUrl}/api/companyboarditems/comments/${this.formData.Slug}?itemID=${this.formData.ID}`)
                .then(resp => {
                    for(const comment of resp.data) {
                        comment.edit = false;
                        comment.commentInput = (comment.Comment || '').replace(/<br\s*\/?>/gi, '\n');
                    }
                    this.comments = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        async submitComment() {
            if(!this.commentInput || this.disableButtonComment) {
                return;
            }
            const data = {
                comment: this.commentInput,
                itemID: this.formData.ID,
                slug: this.formData.Slug
            }
            this.disableButtonComment = true;
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/comment`, data)
                .then(() => {
                    this.commentInput = '';
                    this.getComments();
                    this.getActivity();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error.')
                })
            this.disableButtonComment = false;
        },
        async submitCommentEdit(comment: any) {
            if(!comment.commentInput || this.disableButtonComment) {
                return;
            }
            this.disableButtonComment = true;
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/updatecomment`, { ID: comment.ID, comment: comment.commentInput })
                .then(() => {
                    this.getComments();
                    this.getActivity();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error.')
                })
            this.disableButtonComment = false;
        },
        deleteComment(comment: any) {
            this.commentToDelete = comment;
            this.showConfirmDeleteComment = true;
        },
        async confirmCommentDelete() {
            this.showConfirmDeleteComment = false;
            await axios.delete(`${this.$store.state.apiUrl}/api/companyboarditems/comment/${this.commentToDelete.ID}`)
                .then(() => {
                    this.getComments();
                })
                .catch(e => {
                    alert(e?.response?.data || 'There was an error.');
                })
        },
        async getActivity() {
            await axios.get(`${this.$store.state.apiUrl}/api/companyboarditems/activity/${this.formData.Slug}?itemID=${this.formData.ID}`)
                .then(resp => {
                    this.activity = [];
                    // Drops repeats of the same action by the same person that are next to each other
                    for(let i = 0; i < resp.data.length; i++) {
                        const a = resp.data[i];
                        const prev = resp.data[i - 1];
                        a.DateDisplay = new Date(a.Date).toLocaleString();
                        if(!prev || a.Text != prev.Text || a.Username != prev.Username) {
                            this.activity.push(a);
                        }
                    }
                })
                .catch(e => {
                    console.log(e);
                })
        },
        async deleteItemCB() {
            await axios.delete(`${this.$store.state.apiUrl}/api/companyboarditems/${this.formData.ID}`)
                .then(() => {
                    this.$emit('close');
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error.')
                })

            this.showConfirmDelete = false;
        },
        // Column picker (touch devices) and the move-to-last-column button
        async columnChange() {
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/changecolumn`, { ID: this.formData.ID, Slug: this.formData.Slug, Column: this.formData.Column })
                .then(() => {
                    this.getActivity();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error.')
                })
        },
        moveToLastColumn() {
            this.showMoveLastColumnConfirm = false;
            this.formData.Column = this.lastColumn;
            this.columnChange();
        },
        checklistInputID(index: number): string {
            return `checklist-add-${this.formData.ID}-${index}`;
        },
        checklistPercent(list: any): number {
            return Math.round(list.items.filter((it: any) => it.checked).length / list.items.length * 100);
        },
        showAddChecklistFn() {
            this.addChecklistInput = `Checklist ${this.formData.ChecklistJSON.length + 1}`;
            this.showAddChecklist = true;
            this.$nextTick(() => {
                (this.$refs.addChecklistInput as HTMLInputElement)?.select();
            });
        },
        addChecklist() {
            if(!this.addChecklistInput) {
                return;
            }
            const list = {
                name: this.addChecklistInput,
                items: [],
                showAddItem: false,
                addChecklistItemInput: ''
            }
            this.formData.ChecklistJSON.push(list);
            this.addChecklistInput = '';
            this.showAddChecklist = false;
            this.submitChecklist(false, list.name);
            // Straight into adding the first item
            this.listShowAddItem(this.formData.ChecklistJSON[this.formData.ChecklistJSON.length - 1], this.formData.ChecklistJSON.length - 1);
        },
        // Steps from the Forge become a new checklist on the card
        addForgeSteps(items: any[]) {
            const taken = new Set(this.formData.ChecklistJSON.map((l: any) => l.name));
            let name = 'Steps', n = 2;
            while(taken.has(name)) name = `Steps ${n++}`;
            this.formData.ChecklistJSON.push({ name, items, showAddItem: false, addChecklistItemInput: '' });
            this.submitChecklist(false, name);
        },
        removeChecklist(index: number) {
            this.listIndexToRemove = index;
            this.showConfirmRemoveChecklist = true;
        },
        removeChecklistCB() {
            this.formData.ChecklistJSON.splice(this.listIndexToRemove, 1);
            this.submitChecklist(false, null);
            this.showConfirmRemoveChecklist = false;
        },
        listShowAddItem(list: any, index: number) {
            list.showAddItem = true;
            this.$nextTick(() => {
                document.getElementById(this.checklistInputID(index))?.focus();
            });
        },
        // Adds the item and keeps the input open and focused for the next one
        addChecklistItem(list: any, index: number) {
            if(!list.addChecklistItemInput) {
                return;
            }
            list.items.push({
                name: list.addChecklistItemInput,
                checked: false
            })
            list.addChecklistItemInput = '';
            this.submitChecklist(false, list.name);
            this.listShowAddItem(list, index);
        },
        removeChecklistItem(list: any, index: number) {
            this.checklistToRemoveItem = list;
            this.checklistToRemoveItemIndex = index;
            this.showConfirmRemoveChecklistItem = true;
        },
        removeChecklistItemConfirm() {
            this.checklistToRemoveItem.items.splice(this.checklistToRemoveItemIndex, 1);
            this.submitChecklist(false, this.checklistToRemoveItem.name);
            this.showConfirmRemoveChecklistItem = false;
        },
        // checkChange moves checked items below unchecked ones. activityChecklistName logs the change
        // to that checklist; null (reorders, deletes) skips logging
        async submitChecklist(checkChange: boolean, activityChecklistName: string|null) {
            if(checkChange) {
                for(const list of this.formData.ChecklistJSON) {
                    list.items = [ ...list.items.filter((it: any) => !it.checked), ...list.items.filter((it: any) => it.checked) ];
                }
            }

            const data = {
                id: this.formData.ID,
                slug: this.formData.Slug,
                // Without the add-item input state
                checklist: this.formData.ChecklistJSON.map((list: any) => ({ name: list.name, items: list.items })),
                updatedChecklist: activityChecklistName || undefined
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companyboarditems/checklist`, data)
                .then(() => {
                    if(activityChecklistName) {
                        this.getActivity();
                    }
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error saving the checklist.');
                })
        }
    }
});
</script>
